import { render, staticRenderFns } from "./r-items-holder-page.vue?vue&type=template&id=77dba6f2"
import script from "./r-items-holder-page.vue?vue&type=script&lang=js"
export * from "./r-items-holder-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77dba6f2')) {
      api.createRecord('77dba6f2', component.options)
    } else {
      api.reload('77dba6f2', component.options)
    }
    module.hot.accept("./r-items-holder-page.vue?vue&type=template&id=77dba6f2", function () {
      api.rerender('77dba6f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-items-holder-page.vue"
export default component.exports